import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import Characters from "./components/Characters";
import Arcs from "./components/Arcs";
import FlameSystem from "./components/FlameSystem";
import Growth from "./components/Growth";
import Ending from "./components/Ending";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <Characters />
        <Arcs />
        <FlameSystem />
        <Growth />
        <Ending />
        <Guide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}